<template>
  <div class="menubuilder__tselector">
    <h3>Tea</h3>
    <p class="menubuilder__info">Add your pricing into the relevant boxes</p>
    <ul>

      <template  v-for="(tea, index) in teas" >
        <li :key="`tea-${index}`">
          <!-- <span class="plus" @click="remove(tea)"><span>-</span></span> -->
          <div class="menubuilder__ttitle" v-html="tea.name" />
          <input type="text" class="menubuilder__tprice" v-model="tea.price" />
        </li>
      </template>



    </ul>
    <div class="menubuilder__add" v-if="false" @click="addNewTea">
      <span class="plus"><span>+</span></span>
      <span>Add a tea</span>
    </div>
  </div>
</template>


<script>
  export default {

    data: function () {
      return {
        teas: this.$store.state.teas
      };
    },
    computed: {
    },
    props: [],
    methods: {
      addNewTea() {
        this.$store.addTea('New Tea', '2.40', '')
      },
      remove(tea){
        this.$store.removeTea(tea)
      }
    },
    computed: {
    },
    async mounted() {
    }
  }

</script>


<style lang="sass">
@import "../../../../styles/partials/variables"

#menubuilder
  .menubuilder

    &__info
      font-size: 16px

    &__add
      @include helptext
      padding: 15px
      margin-top: 15px
      text-align: center
      cursor: pointer;

      span.plus
        margin: 15px auto
    &__tselector
      margin-top: 50px;
      ul
        list-style: none
        padding: 0

        li
          display: flex
          flex-flow: row wrap
          justify-content: space-between
          position: relative
          margin-bottom: 10px

          @media screen and (max-width: 767px)
            display: inline-block

            &:first-child
              display: flex
              width: 68%


          span.plus
            flex: 0 1 25px
            height: 25px
            width: 25px
            position: absolute
            top: 12px
            left: -30px
            cursor: pointer
            span
              position: relative
              top: -5px

    &__ttitle
      flex: 0 1 calc(100% - 100px)
      font-size: 22px
      padding-top: 7px
      border-color: transparent
      outline: none;

      &--coffee
        @media screen and (max-width: 767px)
          flex: 0 0 100%;
          width: 100%

      &:focus
        border-bottom: 2px solid $color-grey

    &__tprice
      flex: 0 0 75px
      width: 75px
      font-weight: 600

      @media screen and (max-width: 767px)
        flex: 0 0 calc(25% - 7.5px);
        width: calc(25% - 7.5px)



</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MenuBuilder/TeaSelector.vue